import { useTranslation } from 'core/i18n/i18n';
import { ConnectionStatus } from 'modules/settings/pods/settings-integrations/settings-integrations-active-directory/types/active-directory.type';
import { ActiveDirectoryStatusBase } from './components';
import {
    getListConnectionStatusIconName,
    getListConnectionStatusIconStatus,
    getListConnectionStatusLabel,
} from './active-directory-list-connection-status.business';

interface ActiveDirectoryListConnectionStatusProps {
    status: ConnectionStatus;
    errorMessage?: string;
    lastAttempt?: string;
}

export const ActiveDirectoryListConnectionStatus: React.FC<ActiveDirectoryListConnectionStatusProps> = ({
    status,
    errorMessage,
    lastAttempt,
}) => {
    const { t } = useTranslation();

    const iconName = getListConnectionStatusIconName(status);
    const iconStatus = getListConnectionStatusIconStatus(status);
    const label = t(getListConnectionStatusLabel(status));

    return (
        <ActiveDirectoryStatusBase
            status={status}
            iconName={iconName}
            iconStatus={iconStatus}
            label={label}
            errorMessage={errorMessage}
            lastAttempt={lastAttempt}
        />
    );
};
